import * as React from "react";
import './Login.css';
import * as LoginStore from "./loginStore";
import { connect } from "react-redux";
import { ApplicationState } from "../store";
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import LoginForm from "./LoginForm";
import { Link } from "react-router-dom";
import NarrowInfoContainer from "../components/NarrowInfoContainer";
import ViewHeaderBar from "../components/ViewHeaderBar";
import { localizations } from "../localization/localization";
import IEWarning from "../common/IEWarning";
import { Location } from 'history';

type LoginViewProps = LoginStore.LoginState & typeof LoginStore.actionCreators & { location: Location };

class LoginView extends React.Component<LoginViewProps, any> {
  constructor(props: LoginViewProps) {
    super(props);
  }

  public render() {

    const isIE = require("bowser").msie;

    return (
      <NarrowInfoContainer>
        {isIE ? <IEWarning /> :
          <React.Fragment>
            <Grid item>
              <br />
            </Grid>
            <ViewHeaderBar title={localizations.login.login} />
            {this.props.loginError ?
              <Grid item>
                {this.props.loginError !== null ?
                  <Typography color="error"><strong>{localizations.login.wrongEmailOrPassword}</strong></Typography>
                  : null}
              </Grid> : null}
            {this.props.isLoggingIn ?
              <Grid item>
                <Grid container direction="column" alignItems="center">
                  <Grid item>
                    <CircularProgress />
                  </Grid>
                  <Grid item>
                    <Typography>{localizations.login.loggingIn}</Typography>
                  </Grid>
                </Grid>
              </Grid>
              : <Grid item>
                <LoginForm location={this.props.location} />
              </Grid>
            }
            <Grid item>
              <Link to="/resetpassword"><Button color="primary">{localizations.register.didYouForgetPassword}</Button></Link>
            </Grid>
            <Grid item>
              <Link to="/register/user" ><Button color="primary">{localizations.register.registerUserTitle}</Button></Link>
            </Grid>
          </React.Fragment>}
      </NarrowInfoContainer>
    );
  }
}

const mapStateToProps = (state: ApplicationState, ownProps: { location: Location }) => {
  return {
    login: state.login,
    location: ownProps.location
  }
}

export default connect(
  mapStateToProps,
  LoginStore.actionCreators
)(LoginView);




// WEBPACK FOOTER //
// ./src/login/LoginView.tsx